import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "validation-error"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input_tag = _resolveComponent("el-input-tag")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["preferred_sources", {invalid: $data.validation_error}])
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("label", null, "Preferred Sources", -1 /* HOISTED */)),
      _createVNode(_component_el_input_tag, {
        modelValue: $options.preferred_sources,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.preferred_sources) = $event)),
        placeholder: "Preferred Sources (lightreading.com)",
        delimiter: ",",
        max: $props.maxItems
      }, null, 8 /* PROPS */, ["modelValue", "max"]),
      ($data.validation_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($data.validation_error), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}